export enum CartActionType {
  DUPLICATE_ITEMS = 'DUPLICATE_ITEMS',
  ITEM_UN_AVAILABLE = 'ITEM_UN_AVAILABLE',
  GET_CART = 'GET_CART',
  GET_SAVING_PLAN = 'GET_SAVING_PLAN',
  GET_SAVED_FOR_LATER_CART = 'GET_SAVED_FOR_LATER_CART',

  ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART',
  ADD_SAVING_PLAN = 'ADD_SAVING_PLAN',
  ADD_ITEM_TO_SAVE_FOR_LATER = 'ADD_ITEM_TO_SAVE_FOR_LATER',

  ADJUST_ITEM_IN_CART = 'ADJUST_ITEM_IN_CART',
  UPDATE_CART_PRICE = 'UPDATE_CART_PRICE',

  MOVE_ITEM_TO_SAVED_FOR_LATER = 'MOVE_ITEM_TO_SAVED_FOR_LATER',

  MOVE_ITEM_TO_CART_FROM_SAVED_FOR_LATER = 'MOVE_ITEM_TO_CART_FROM_SAVED_FOR_LATER',
  REMOVE_ITEM_FROM_SAVED_FOR_LATER = 'REMOVE_ITEM_FROM_SAVED_FOR_LATER',

  REMOVE_SAVING_PLAN = 'REMOVE_SAVING_PLAN',
  REMOVE_ITEM_FROM_CART = 'REMOVE_ITEM_FROM_CART',

  INVALID_QUOTES = 'INVALID_QUOTES',
  EXIPRED_RX_ITEMS_IN_CART = 'EXIPRED_RX_ITEMS_IN_CART',

  CLOSE_MODEL = 'CLOSE_MODEL',
}

export enum ProductStatusType {
  INFO = 'info',
  WARNINING = 'warning',
  ERROR = 'error',
  CONFIRM = 'confirm',
  EMPTY = '',
  SUCCESS = 'regCheckCircle',
}

export interface ITextConfig {
  prop: string;
  value: string;
  linkUrl?: string;
}

export interface ICartProductStatus {
  action: CartActionType;
  type: ProductStatusType;
  title: string;
  description: string;
  error?: any;
  titleConfig?: ITextConfig[];
  descriptionConfig?: ITextConfig[];
}

export interface ICartAction {
  type: CartActionType;
  payload: ICartProductStatus;
}

export enum CartStatusCodeEnum {
  DUPLICATE_ITEMS_TITLE = 'cart.items.duplicateItems.lbl',
  DUPLICATE_ITEMS_DESCRIPTION = 'cart.items.duplicateItems.description',
  ITEM_UN_AVAILABLE_TITLE = 'cart.items.unAvailable.title.lbl',
  ITEM_UN_AVAILABLE_DESCRIPTION = 'cart.items.unAvailable.description.lbl',
  ITEM_REMOVED_FROM_CART = 'cart.removedFromCart.description',
  CART_SAVED_FOR_LATER_TITLE = 'cart.savedForLater.lbl',
  ITEM_MOVED_TO_SAVED_FOR_LATER = 'cart.movedToSavedForLater.description',
  GENERAL_CART_FAILURE_TITLE = 'cart.error.general.title.lbl',
  GENERAL_CART_FAILURE_DESCRIPTION = 'cart.error.general.desc.lbl',
  EXIPRED_RX_ITEMS_IN_CART_TITLE = 'cart.error.rxExpired.label',
  EXIPRED_RX_ITEMS_IN_CART_DESCRIPTION = 'cart.error.rxExpired.descripton',

  PRICING_ENGINE_FAIL = 'cart.error.priceEngine.lbl',
  PRICING_ENGINE_BENEFITS_FAIL = 'cart.error.priceEngineBenefits.lbl',
  ADD_TO_CART_FAIL = 'cart.error.addToCart.lbl',
  REMOVE_ITEM_FROM_CART_FAIL = 'cart.error.removeFromCart.lbl',
  ADJUST_ITEM_IN_CART_FAIL = 'cart.error.adjustItemsInCart.lbl',
  GET_SAVED_FOR_LATER_CART_FAIL = 'cart.error.getSavedForLaterCart.lbl',
  ADD_SAVE_FOR_LATER_CART_FAIL = 'cart.error.addToSavedForLater.lbl',
  MOVE_SAVED_FOR_LATER_TO_CART_FAIL = 'cart.error.moveSavedForLaterToCart.lbl',
  MOVE_CART_TO_SAVED_FOR_LATER_FAIL = 'cart.error.moveCartToSavedForLater.lbl',
  REMOVE_SAVED_FOR_LATER_FAIL = 'cart.error.removeFromSaveForLater.lbl',

  // REMOVE_FROM_SAVED_FOR_LATER_SUCCESS = 'cart.removeFromSaveForLater.lbl',

  BENEFITS_API_ERROR_TITLE = 'cart.error.benefitsApiError.title.lbl',
  BENEFITS_API_ERROR_DESC = 'cart.error.benefitsApiError.desc.lbl',
  BENEFITS_USED_API_ERROR_TITLE = 'cart.error.benefitsApiUsedError.title.lbl',
  BENEFITS_USED_API_ERROR_DESC = 'cart.error.benefitsApiUsedError.desc.lbl',
  BEST_SAVINGS_NCAL_API_ERROR_TITLE = 'cart.savings.modal.NCAL.title',
  BEST_SAVINGS_NCAL_API_ERROR_DESC = 'cart.savings.modal.NCAL.description',
  BEST_SAVINGS_SCAL_API_ERROR_TITLE = 'cart.savings.modal.SCAL.title',
  BEST_SAVINGS_SCAL_API_ERROR_DESC = 'cart.savings.modal.SCAL.description',
  UNUSED_BENEFITS = 'cart.error.unusedBenefits.lbl',
  USED_BENEFITS = 'cart.error.usedBenefits.lbl',
}

export enum SavedForLaterSatusCodeEnum {
  ITEM_REMOVED_FROM_SAVED_FOR_LATER_TITLE = 'savedForLater.itemRemoved.labl',
  ITEM_REMOVED_FROM_SAVED_FOR_LATER_DESCRIPTION = 'savedForLater.itemRemoved.description',

  ITEM_MOVED_FROM_SAVED_FOR_LATER_TO_CART_TITLE = 'savedForLater.itemMoved.labl',
  ITEM_MOVED_FROM_SAVED_FOR_LATER_TO_CART_DESCRIPTION = 'savedForLater.itemMoved.description',
  GENERAL_SAVEDFORLATER_FAILURE_TITLE = 'savedForLater.error.general.lbl',
  GENERAL_SAVEDFORLATER_FAILURE_DESCRIPTION = 'savedForLater.error.general.description',

  REMOVE_INVALID_QUOTE_TITLE = 'savedForLater.invalidQuote.labl',
  REMOVE_INVALID_QUOTE_DESCRIPTION = 'savedForLater.invalidQuote.description',
}
